import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  onBack?: () => void;
  onSkip?: () => void;
}
export function ProgressBar({
  currentStep,
  totalSteps,
  onBack,
  onSkip
}: ProgressBarProps) {
  let phase = 'Icebreaker';
  if (currentStep >= 3 && currentStep <= 6) phase = 'Deep Dive';
  if (currentStep >= 7 && currentStep <= 10) phase = 'Strategy';
  if (currentStep >= 11) phase = 'Share Back';
  const progress = currentStep / totalSteps * 100;
  return <div className="fixed top-0 left-0 w-full z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-29">
      <div className="max-w-4xl mx-auto px-4 py-3 flex justify-between items-center text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-30">
        <button onClick={onBack} disabled={currentStep <= 1} className="flex items-center gap-1 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors normal-case tracking-normal" aria-label="Go back" data-id="element-31">
          <ChevronLeft size={16} data-id="element-32" />
          <span className="hidden sm:inline" data-id="element-33">Back</span>
        </button>

        <div className="flex space-x-5" data-id="element-34">
          <span className={phase === 'Icebreaker' ? 'text-brand' : ''} data-id="element-35">
            Icebreaker
          </span>
          <span className={phase === 'Deep Dive' ? 'text-brand' : ''} data-id="element-36">
            Deep Dive
          </span>
          <span className={phase === 'Strategy' ? 'text-brand' : ''} data-id="element-37">
            Strategy
          </span>
          <span className={phase === 'Share Back' ? 'text-brand' : ''} data-id="element-38">
            Share Back
          </span>
        </div>

        <button onClick={onSkip} disabled={currentStep >= totalSteps} className="flex items-center gap-1 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors normal-case tracking-normal" aria-label="Skip forward" data-id="element-39">
          <span className="hidden sm:inline" data-id="element-40">Skip</span>
          <ChevronRight size={16} data-id="element-41" />
        </button>
      </div>
      <div className="h-1 w-full bg-gray-100" data-id="element-42">
        <motion.div className="h-full bg-brand" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-43" />
      </div>
    </div>;
}